import script from "./GboalHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./GboalHeader.vue?vue&type=script&setup=true&lang=ts"

import "./GboalHeader.vue?vue&type=style&index=0&id=3164c51f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3164c51f"]])

export default __exports__